import { render, staticRenderFns } from "./ItemStatistics.vue?vue&type=template&id=d025e4fe&scoped=true&"
import script from "./ItemStatistics.vue?vue&type=script&lang=js&"
export * from "./ItemStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ItemStatistics.vue?vue&type=style&index=0&id=d025e4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d025e4fe",
  null
  
)

export default component.exports